import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter } from "app/main/std";
import { observeResource } from "kea-resource";
import { RolForm } from "./form";
type Entity = models.Rol;
const resource = resources.Rol;
const observable = observeResource(resources.Rol.query);

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class RolEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            return models.RolDefault;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("/catalogos/Rol");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return (<RolForm
            value={this.state.value}
            onChange={this.onChange}
            onGuardar={this.onGuardar} />)
    }
}

export const RolEdit = withRouter(RolEditComp);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/edit.tsx